<!-- 
Dialog for configuring the provider contact status (primary / secondary / none). This overrides the value derived from HITS.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <v-form>
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Change Provider Contact Status for {{ contactStatusType }}</v-toolbar-title>
          <v-spacer/>
          <our-user-guide-button topic="listing-providers" section="contacts"/>
        </v-toolbar>
        <our-busy-indicator :show="busy"/>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-radio-group v-model="selectedContactStatus" mandatory>
                  <template v-slot:label>
                    <div>
                      <p>Change the {{ contactStatusType }} status of <strong>{{ contact.name }}</strong>.</p>
                    </div>
                  </template>
                  <v-radio value="Primary" color="primary">
                    <template v-slot:label>
                      <div>Set as Primary Contact</div>
                    </template>
                  </v-radio>
                  <v-radio value="Secondary" color="primary">
                    <template v-slot:label>
                      <div>Set as Secondary Contact</div>
                    </template>
                  </v-radio>
                  <v-radio value="" color="primary">
                    <template v-slot:label>
                      <div>None</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-flex>            
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="busy" flat @click.native="hide">Cancel</v-btn>
          <v-btn 
            ref="save-button" :disabled="busy" flat color="primary" 
            type="submit" @click.prevent="save"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import ruleMixins from "@/mixins/rule.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/provider-contacts/action-types";

export default {
  mixins: [ruleMixins, lookupMixins, filterMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    contactId: {
      type: Number,
      default: null
    },
    contactStatusType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedContactStatus: null
    };
  },
  computed: {
    state() {
      return this.$store.state.providerContacts.changeStatus;
    },
    contact() {
      return this.state.data;
    },
    busy() {
      return this.state.loading || this.state.saving;
    },
    typeForSave() {
      return this.contactStatusType == "VET" ? "vsl" : "help";
    },
    contactType() {
      return this.contact == null ? "" : this.contact.type == null ? "Not specified" : this.contact.type;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        await this.$store.dispatch(action.GET, { contactId: this.contactId });
        var status = this.contactStatusType == "VET" ? this.contact.vslStatus : this.contact.helpStatus;
        this.selectedContactStatus = status == null ? "" : status;
      }
    }
  },
  methods: {
    async save() {
      if (
        await this.$store.dispatch(action.SET_STATUS_SAVE, {
          contactId: this.contactId,
          type: this.typeForSave,
          newStatus: this.selectedContactStatus
        })
      ) {
        this.hide();
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
